<section class="rounded-xl p-4 bg-white">
    <div class="flex justify-end w-full pb-4" header>
        <button class="flex items-center cursor-pointer" (click)="close()">
            <app-icon name="mdi:close" class="text-gray-800" />
        </button>
    </div>
    <div class="flex flex-col gap-3">
        <div class="flex gap-3 items-center">
            <p class="text-sm text-gray-800">초기화</p>
            <p class="text-sm text-gray-500">
                튜토리얼로 등록한 내용이 모두 삭제 됩니다.
            </p>
        </div>
        <div class="flex gap-3 items-center">
            <p class="text-sm text-gray-800">저장</p>
            <p class="text-sm text-gray-500">
                튜토리얼로 등록한 내용이 유지된채 활동할 수 있습니다.
            </p>
        </div>
    </div>
</section>
